export { default as CropSolidIcon } from './CropSolidIcon';
